<template>

  <div class="elevation-2 search-box white" v-if="searching">

    <v-toolbar flat="flat">
      <v-toolbar-title class="search-title">Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="search-bt"
              title="Hide the search"
              @click="closeSearch">mdi-magnify-close</v-icon>
    </v-toolbar>

    <v-container fluid="fluid" grid-list-md="grid-list-md">

      <v-layout row="row" wrap="wrap">

        <!-- SPORT -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <SportSelector ref="sportSelector"
                         :currentSportIDs="searchParams.sportID"
                         @sportSelected="sportSelected"/>
        </v-flex>

        <!-- FEDERATION -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <FederationSelector ref="federationSelector"
                              :currentFederationID="searchParams.federationID"
                              :sportID="searchParams.sportID"
                              @federationSelected="federationSelected"/>
        </v-flex>

        <!-- COMPETITION -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <CompetitionSelector ref="competitionSelector"
                               :federationID="searchParams.federationID"
                               :currentCompetitionID="searchParams.competitionID"
                               @competitionSelected="competitionSelected"/>
        </v-flex>

        <!-- PLACE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <PlaceSelector ref="placeSelector"
                         :currentPlaceID="searchParams.placeID"
                         @placeSelected="placeSelected"/>
        </v-flex>

        <!-- CLUB 1 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="club1Selector"
                           :currentClubID="searchParams.clubID"
                           :sportID="searchParams.sportID"
                           :label="'Club 1'"
                           @clubSelected="club1Selected"/>
        </v-flex>

        <!-- CLUB 2 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWClubSelector ref="club2Selector"
                           :currentClubID="searchParams.otherClubID"
                           :sportID="searchParams.sportID"
                           :label="'Club 2'"
                           @clubSelected="club2Selected"/>
        </v-flex>

        <!-- TEAM 1 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5" v-if="$country === 'US'">
          <TeamSelector ref="team1Selector"
                        :currentTeamID="searchParams.teamID"
                        :clubID="searchParams.clubID"
                        :disabled="!searchParams.clubID"
                        :disabledText="'Please select club 1 first'"
                        :label="'Team 1'"
                        @teamSelected="team1Selected"/>
        </v-flex>

        <!-- TEAM 2 -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5" v-if="$country === 'US'">
          <TeamSelector ref="team2Selector"
                        :currentTeamID="searchParams.otherTeamID"
                        :clubID="searchParams.otherClubID"
                        :disabled="!searchParams.otherClubID"
                        :disabledText="'Please select club 2 first'"
                        :label="'Team 2'"
                        @teamSelected="team2Selected"/>
        </v-flex>

        <!-- START DATE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <DateSelector ref="startDateSelector"
                        :currentDate="searchParams.startDate"
                        :label="'From'"
                        @dateSelected="startDateSelected"/>
        </v-flex>

        <!-- END DATE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <DateSelector ref="endDateSelector"
                        :currentDate="searchParams.endDate"
                        :label="'To'"
                        @dateSelected="endDateSelected"/>
        </v-flex>

        <!-- HAS VIDEOS -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <HasVideos ref="hasVideosSelector"
                     :currentValue="searchParams.hasVideos"
                     @input="hasVideosSelected"/>
        </v-flex>

        <!-- USER -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <NEWUserSelector ref="userSelector"
                           :label="'Has videos from'"
                           :currentUserID="searchParams.hasVideosFrom"
                           @userSelected="userSelected"/>
        </v-flex>

      </v-layout>

      <v-layout row="row" wrap="wrap">
        <v-spacer></v-spacer>
        <v-btn class="search-action" :small="true" color="primary" flat="flat" @click.native="clearSearch">Clear</v-btn>
        <v-btn class="search-action" :small="true" color="primary" @click.native="search">Search</v-btn>
      </v-layout>

    </v-container>

  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import FederationSelector from '../common/FederationSelector'
import CompetitionSelector from '../common/CompetitionSelector'
import PlaceSelector from '../common/PlaceSelector'
import NEWClubSelector from '../common/NEWClubSelector'
import TeamSelector from '../common/TeamSelector'
import DateSelector from '../common/DateSelector'
import HasVideos from '../common/HasVideos'
import NEWUserSelector from '../common/NEWUserSelector'

export default {
  name: 'Search',
  components: {
    SportSelector,
    FederationSelector,
    CompetitionSelector,
    PlaceSelector,
    NEWClubSelector,
    TeamSelector,
    DateSelector,
    HasVideos,
    NEWUserSelector
  },
  props: ['searching'],
  data () {
    return {
      searchParams: {
        sportID: '',
        federationID: '',
        competitionID: '',
        placeID: '',
        clubID: '',
        otherClubID: '',
        teamID: '',
        otherTeamID: '',
        startDate: '',
        endDate: '',
        hasVideos: false,
        hasVideosFrom: ''
      }
    }
  },
  methods: {
    search () {
      this.$emit('search', this.searchParams)
    },

    clearSearch () {
      this.$refs.sportSelector.clear()
      this.$refs.federationSelector.clear()
      this.$refs.competitionSelector.clear()
      this.$refs.placeSelector.clear()
      this.$refs.club1Selector.clear()
      this.$refs.club2Selector.clear()
      if (this.$refs.team1Selector) {
        this.$refs.team1Selector.clear()
      }
      if (this.$refs.team2Selector) {
        this.$refs.team2Selector.clear()
      }
      this.$refs.startDateSelector.clear()
      this.$refs.endDateSelector.clear()
      this.$refs.hasVideosSelector.clear()
      this.$refs.userSelector.clear()

      this.searchParams = {
        name: '',
        sportID: '',
        federationID: '',
        placeID: '',
        clubID: '',
        otherClubID: '',
        teamID: '',
        otherTeamID: '',
        startDate: '',
        endDate: '',
        hasVideos: false,
        hasVideosFrom: ''
      }
      this.$emit('clearSearch')
    },

    closeSearch () {
      this.$emit('closeSearch')
    },

    sportSelected (sportid) {
      this.searchParams.sportID = sportid
    },
    federationSelected (federationid) {
      this.searchParams.federationID = federationid
    },
    competitionSelected (competitionid) {
      this.searchParams.competitionID = competitionid
    },
    placeSelected (placeid) {
      this.searchParams.placeID = placeid
    },
    club1Selected (clubid) {
      this.searchParams.clubID = clubid
    },
    club2Selected (clubid) {
      this.searchParams.otherClubID = clubid
    },
    team1Selected (teamid) {
      this.searchParams.teamID = teamid
    },
    team2Selected (teamid) {
      this.searchParams.otherTeamID = teamid
    },
    startDateSelected (date) {
      this.searchParams.startDate = date
    },
    endDateSelected (date) {
      this.searchParams.endDate = date
    },
    hasVideosSelected (input) {
      this.searchParams.hasVideos = input
    },
    userSelected (userid) {
      this.searchParams.hasVideosFrom = userid
    }
  }
}

</script>

<style lang="scss" scoped>

  .search-box {
    margin-bottom: 30px;
  }

  .search-title {
    font-size: 1rem;
    font-weight: 700;
  }

  .field {
    margin: 0 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/matches/Search.vue